import { render, staticRenderFns } from "./DisputeBoard.vue?vue&type=template&id=536390b2&"
import script from "./DisputeBoard.vue?vue&type=script&lang=js&"
export * from "./DisputeBoard.vue?vue&type=script&lang=js&"
import style0 from "./DisputeBoard.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports